const prefix = 'nxt';
const iconName = 'phoneSlash';
const width = 1024;
const height = 1024;
const ligatures = [];
const unicode = '';
const svgPathData =
  'M8.998 855.734l957.177-747.495c11.204-9.604 27.214-6.403 36.814 3.201l16.010 20.809c8.003 11.205 6.397 27.212-4.806 35.214l-957.175 749.097c-9.604 8.003-27.212 6.397-35.214-4.806l-16.005-19.206c-9.604-11.204-6.403-27.208 3.201-36.814zM378.744 447.572c3.201 4.806 6.402 9.607 9.604 16.010l-60.824 46.421c-14.406-25.611-30.412-52.824-44.818-83.235l108.844-89.636-67.227-156.861-145.658 33.613c1.601 123.248 38.415 238.495 99.239 336.13l-60.824 46.421c-72.028-110.442-113.644-243.294-113.644-385.751 0-33.613 22.41-64.026 56.023-72.028l150.46-33.613c35.214-8.003 70.427 9.604 83.232 41.616l70.429 163.264c12.802 28.811 4.801 64.026-20.81 84.833l-64.024 52.818zM810.915 844.531l33.612-144.054-156.863-67.231-89.632 108.844c-41.62-20.81-78.434-41.615-112.046-64.023l64.023-49.623c9.607 6.404 17.608 12.802 27.214 17.608l52.818-64.028c20.81-25.611 56.026-33.612 84.839-20.805l163.26 68.822c32.014 14.406 49.623 49.623 41.62 84.839l-33.617 150.458c-8.003 33.612-38.412 56.020-72.024 56.020-166.468 0-320.129-57.624-441.776-153.661l62.425-49.623c105.643 80.033 235.291 126.453 376.149 126.453z';

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtPhoneSlash = definition;

export { definition, nxtPhoneSlash, prefix, iconName, width, height, ligatures, unicode, svgPathData };
